import {lazy} from 'react';
import UploadAddress from './uploadAddress';
import uploadAddressFocus from './uploadAddressFocus';

// error组件
const Error = () => import(/* webpackChunkName: 'Error' */ '@/components/Error');

const routes = [
  ...UploadAddress,
  ...uploadAddressFocus,
  {
    title: '页面错误',
    path: '/error',
    key: 'Error',
    component: lazy(Error),
    exact: true
  },
];

export default routes;
